import {HttpClient} from '@angular/common/http';
import {Injectable} from "@angular/core";

@Injectable({
    providedIn: 'root'
})

export class ContentControllerService{

    constructor(private http: HttpClient){}

    getPage(slug) {
        const url = '/gliders/api/cms/pages/?type=content.ContentPage&fields=*&slug='+slug;
        return this.http.get(url).toPromise();

    }

    getEquipment(){
        const url = '/gliders/api/cms/equipment/';
        return this.http.get(url).toPromise();
    }

    getGliders(id){
        const url = '/gliders/api/cms/equipment/'+id;
        return this.http.get(url).toPromise();
    }
}
